import { Grid } from '@enterprise-ui/canvas-ui-react';
import React__default from 'react';
import { usePagination } from './utils/hooks.js';

var ShowItems = function ShowItems(_ref) {
  var dataTestId = _ref.dataTestId;
  var _usePagination = usePagination(),
    _usePagination$state = _usePagination.state,
    hideShowItems = _usePagination$state.hideShowItems,
    itemRange = _usePagination$state.itemRange,
    totalItems = _usePagination$state.totalItems,
    totalPages = _usePagination$state.totalPages;
  var hasPages = totalPages > 1;
  var displayString = hasPages && "".concat(itemRange === null || itemRange === void 0 ? void 0 : itemRange.start, "-").concat(itemRange === null || itemRange === void 0 ? void 0 : itemRange.end, " of ");
  return /*#__PURE__*/React__default.createElement(Grid.Item, {
    className: "C-Pagination__childComponent",
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Grid.Container, {
    className: "C-Pagination__showItems hc-mb-normal"
  }, /*#__PURE__*/React__default.createElement(Grid.Item, null, hideShowItems !== true && /*#__PURE__*/React__default.createElement("p", {
    "data-testid": dataTestId ? "".concat(dataTestId, "_showItems") : null,
    className: "hc-clr-grey01",
    "aria-live": "polite"
  }, "Showing ", displayString, totalItems, " items"))));
};

export { ShowItems as default };
